export type NSType = 'HUD';
export const NS: NSType = 'HUD';

export type HUDState = 'loading' | 'success' | 'error' | 'closed';

export function initialHUDState(): HUDState {
  return 'closed';
}
